import { handleResponseError } from './handleResponseError';

export async function handleResponse(res: Response) {
  const contentTypeHeader = res.headers.get('content-type');
  const isContentTypeJson = contentTypeHeader?.includes('application/json');
  const isContentTypeText = contentTypeHeader?.includes('text/');
  const isContentTypeImage = contentTypeHeader?.includes('image/jpeg');
  const isContentTypeBlob = !isContentTypeJson && contentTypeHeader?.includes('application/');
  const contentDisposition = res.headers.get('content-disposition');

  const data =
    (!contentDisposition && isContentTypeJson && (await res.json())) ||
    (isContentTypeText && (await res.text())) ||
    ((contentDisposition || isContentTypeBlob || isContentTypeImage) && (await res.blob()));

  if (!res.ok) {
    const errorData = isContentTypeJson
      ? data
      : {
          status: res.status,
          statusText: res.statusText,
        };
    return Promise.reject(handleResponseError(errorData));
  }
  return data;
}
